import React from 'react'
import SbEditable from 'storyblok-react'
import Headline from '../atoms/Headline'
import ContactPersonBlock from './ContactPersonBlock'

const TeamBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section
        className={`team-block ${block.space_top ? block.space_top : ''} ${
          block.space_bottom ? block.space_bottom : ''
        }`}
      >
        <div className="team-block-container">
          <Headline
            kicker={block.kicker}
            headline={block.headline}
            subheadline={block.subheadline}
          />
          <div className="team-block-row justify-content-start">
            {block.team_members?.length > 0 &&
              block.team_members.map((item, index) => (
                <ContactPersonBlock block={item} key={index} />
              ))}
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default TeamBlock
